import { RealtimeConnectionIndicator } from "@shared/modules/realtime/components/RealtimeConnectionIndicator.web";
import { REALTIME_CONNECTION_STATES } from "@shared/modules/realtime/constants/realtime-connection-constants";
import Box from "@ui-kit/layout/Box/Box.web";
import { useRealtimeSeatingStatus } from "../hooks/useRealtimeSeatingStatus";

const HIDDEN_STATES = [
  REALTIME_CONNECTION_STATES.ERROR,
  REALTIME_CONNECTION_STATES.DISCONNECTED,
];

export function SeatingRealtimeStatus(): React.ReactElement | null {
  const { isEnabled, connectionInfo } = useRealtimeSeatingStatus();

  if (!isEnabled) {
    return null;
  }

  return (
    <Box
      position="absolute"
      top="md"
      left="md"
      zIndex="seatingMap"
      display={{ base: "none", sm: "block" }}
    >
      <RealtimeConnectionIndicator
        connectionInfo={connectionInfo}
        hiddenStates={HIDDEN_STATES}
      />
    </Box>
  );
}
